import React, { useState, useRef } from "react";
import { CSVLink } from "react-csv";
import { TailSpin } from "react-loader-spinner";

const ExportCSV = ({
  fetchData,
  headers = [],
  filename = "download.csv",
  buttonLabel = "Download CSV",
  dataFormatter = (data) => data.data,
  headerAndDataFunctionCombined = null,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const csvLinkRef = useRef();
  const [finalHeaders, setHeaders] = useState(headers);

  const handleDownload = async () => {
    setLoading(true);

    try {
      const fetchedData = await fetchData();
      if (headerAndDataFunctionCombined) {
        const { data: constructedData, headers: constructedHeaders } = headerAndDataFunctionCombined(fetchedData);
        setData(constructedData);
        setHeaders(constructedHeaders);
      } else {
        setData(dataFormatter(fetchedData));
      }


      setTimeout(() => {
        csvLinkRef.current?.link.click();
      }, 0);
    } catch (error) {
      console.error("Error fetching CSV data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={handleDownload}
        disabled={loading}
        className="relative bg-[#F1F4FB] p-2 rounded-md flex items-center gap-2"
      >
        {loading ? (
          <TailSpin color="#374151" height={20} width={20} />
        ) : (
          <span>{buttonLabel}</span>
        )}
      </button>

      {
        finalHeaders.length > 0 ?
          <CSVLink
            data={data}
            filename={filename}
            className="hidden"
            ref={csvLinkRef}
            target="_blank"
            headers={finalHeaders}
          /> :
          <CSVLink
            data={data}
            filename={filename}
            ref={csvLinkRef}
            className="hidden"
            target="_blank"
          />
      }
    </div>
  );
};

export default ExportCSV;
